export const hoursInYear = 365 * 24
